import React, { FC } from 'react'
import { matchPath, useLocation, useParams } from 'react-router-dom'
import { Breadcrumb } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { isPathRegex } from '@shared/tools/path.tools'

const Breadcrumbs: FC = () => {
  const { playlistId } = useParams()
  const location = useLocation()

  return (
    <div className="my-2">
      <Breadcrumb>
        <LinkContainer to={`/playlist/create`}>
          <Breadcrumb.Item
            active={!!matchPath(location.pathname, `/playlist/create`)}
          >
            Založení
          </Breadcrumb.Item>
        </LinkContainer>

        {playlistId && (
          <>
            <LinkContainer to={`/playlist/${playlistId}/outline`}>
              <Breadcrumb.Item
                active={isPathRegex(
                  location.pathname,
                  new RegExp(`^/playlist/${playlistId}/outline.*$`)
                )}
              >
                Dramaturg
              </Breadcrumb.Item>
            </LinkContainer>
            <LinkContainer to={`/playlist/${playlistId}`}>
              <Breadcrumb.Item
                active={isPathRegex(
                  location.pathname,
                  new RegExp(
                    `^/playlist/${playlistId}(?!/outline|/audio|/published).*$`
                  )
                )}
              >
                Moderátor
              </Breadcrumb.Item>
            </LinkContainer>
            <LinkContainer to={`/playlist/${playlistId}/audio`}>
              <Breadcrumb.Item
                active={
                  !!matchPath(
                    location.pathname,
                    `/playlist/${playlistId}/audio`
                  )
                }
              >
                Revize audia
              </Breadcrumb.Item>
            </LinkContainer>
            <LinkContainer to={`/playlist/${playlistId}/published`}>
              <Breadcrumb.Item
                active={
                  !!matchPath(
                    location.pathname,
                    `/playlist/${playlistId}/published`
                  )
                }
              >
                Publikace
              </Breadcrumb.Item>
            </LinkContainer>
          </>
        )}
      </Breadcrumb>
    </div>
  )
}

export default Breadcrumbs
